{
  "CHANGELOG": {
    "VIEW_ALL": "View all"
  }
}
